import React from "react";
import AssignReferralList from "../../component/Referral/AssignReferralList.tsx";

const AssignReferralPage = () => {
  return (
    <div>
      <AssignReferralList />
    </div>
  );
};

export default AssignReferralPage;
